import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import swal from "sweetalert";
import { useOrganisations } from "../Auth/useOrganisations";
import GifLoader from "../Components/loader";
import { useTranslation } from "react-i18next";
import { getRaccourcisByOrganisation } from "../Services/MenuApi";
import { getImageUrl } from "../Helpers/Helpers";

function RaccourciList() {
  const { t } = useTranslation();
  const [raccourcis, setRaccourcis] = useState([]);
  const [loading, setLoading] = useState(true);
  const [
    organisations,
    setOrganisations,
    usedOrganisations,
    setUsedOrganisations,
  ] = useOrganisations();
  useEffect(() => {
    loadRaccourcis();
  }, [usedOrganisations]);

  const loadRaccourcis = async () => {
    try {
      setLoading(true);
      const response = await getRaccourcisByOrganisation(usedOrganisations);
      console.log(response);

      if (response.success) {
        setRaccourcis(response.data.data);
      } else {
        setRaccourcis([]);
      }
    } catch (error) {
      console.error("Error loading raccourcis:", error);
      swal("Erreur!", "Impossible de charger les raccourcis", "error");
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = (id, name) => {
    swal({
      title: "Supprimer ce raccourci?",
      text: `"${name}" sera définitivement supprimé`,
      icon: "warning",
      buttons: ["Annuler", "Supprimer"],
      dangerMode: true,
    }).then(async (willDelete) => {
      if (willDelete) {
        // try {
        //   const response = await deleteRaccourci(id);
        //   if (response.data.success) {
        //     swal("Supprimé!", "Le raccourci a été supprimé", "success");
        //     loadRaccourcis();
        //   } else {
        //     throw new Error(response.data.message);
        //   }
        // } catch (error) {
        //   swal("Erreur!", "Impossible de supprimer le raccourci", "error");
        // }
      }
    });
  };

  return (
    <section className="content">
      <GifLoader loading={loading} />

      {/* Header */}
      <div className="row mb-4">
        <div className="col-md-8">
          <h2>
            <i className="fa fa-link text-primary mr-2"></i>
            Raccourcis
          </h2>
        </div>
        <div className="col-md-4">
          <div className="d-flex justify-content-end gap-2">
            <Link to="/menus" className="btn btn-secondary">
              <i className="fa fa-arrow-left mr-2"></i>
              Retour aux produits
            </Link>
          </div>
        </div>
      </div>

      {/* Raccourcis Grid */}
      {raccourcis.length === 0 ? (
        <div className="card">
          <div className="card-body text-center py-5">
            <i className="fa fa-link fa-4x text-muted mb-3"></i>
            <h4 onClick={() => console.log(raccourcis)}>
              Aucun raccourci trouvé
            </h4>
            <p className="text-muted mb-4">
              Créez votre premier raccourci depuis la page des produits
            </p>
            <Link to="/menus" className="btn btn-primary">
              <i className="fa fa-plus mr-2"></i>
              Créer un raccourci
            </Link>
          </div>
        </div>
      ) : (
        <div className="row">
          {raccourcis.map((raccourci) => (
            <div key={raccourci.id} className="col-md-4 mb-4">
              <div className="card">
                <div className="card-header bg-primary text-white">
                  <h5 className="card-title mb-0">
                    <i className="fa fa-th-large mr-2"></i>
                    {raccourci.raccourci_name}
                  </h5>
                </div>
                <div className="card-body">
                  <div className="row">
                    {raccourci.items && raccourci.items.length > 0 ? (
                      raccourci.items.slice(0, 4).map((shortcut, index) => (
                        <div key={index} className="col-3 mb-2">
                          <div
                            className="text-center"
                            onClick={() => console.log(shortcut)}
                          >
                            {shortcut.product_id?.image ? (
                              <img
                                src={getImageUrl(shortcut.product_id.image)}
                                onError={(e) => {
                                  e.target.onerror = null;
                                  e.target.src = "images/product/no-image.png";
                                }}
                                alt={shortcut.product_name}
                                className="img-fluid rounded"
                                style={{
                                  width: "50px",
                                  height: "50px",
                                  objectFit: "cover",
                                }}
                              />
                            ) : (
                              <div
                                className="bg-light rounded d-flex align-items-center justify-content-center"
                                style={{ width: "50px", height: "50px" }}
                              >
                                <i className="fa fa-image text-muted"></i>
                              </div>
                            )}
                            <small
                              className="d-block text-truncate"
                              style={{ fontSize: "10px" }}
                            >
                              {shortcut.product_name}
                            </small>
                          </div>
                        </div>
                      ))
                    ) : (
                      <div className="col-12 text-center text-muted">
                        <p>Aucun produit dans ce raccourci</p>
                      </div>
                    )}
                  </div>
                  {raccourci.shortcuts && raccourci.shortcuts.length > 4 && (
                    <div className="text-center mt-2">
                      <span className="badge badge-info">
                        +{raccourci.shortcuts.length - 4} autres
                      </span>
                    </div>
                  )}
                </div>
                <div className="card-footer d-flex justify-content-between">
                  <small className="text-muted">
                    <i className="fa fa-calendar mr-1"></i>
                    {new Date(raccourci.created_at).toLocaleDateString()}
                  </small>
                  <div>
                    <Link
                      to={`/raccourcis/edit/${raccourci.raccourci_name}`}
                      className="btn btn-sm btn-warning mr-1"
                      title="Modifier"
                    >
                      <i className="fa fa-edit"></i>
                    </Link>
                    <button
                      onClick={() =>
                        handleDelete(raccourci.id, raccourci.raccourci_name)
                      }
                      className="btn btn-sm btn-danger"
                      title="Supprimer"
                    >
                      <i className="fa fa-trash"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </section>
  );
}

export default RaccourciList;
